import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zhuyi",
  "use": "icon-zhuyi-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-zhuyi\"><path d=\"M512 0C229.376 0 0 229.376 0 512s229.376 512 512 512 512-229.376 512-512S794.624 0 512 0z m0 950.784c-242.176 0-438.784-196.608-438.784-438.784 0-242.176 196.608-438.784 438.784-438.784 242.176 0 438.784 196.608 438.784 438.784 0 242.176-196.608 438.784-438.784 438.784zM502.272 616.96c16.384 0 29.696-12.8 30.208-28.672l13.312-300.032c1.024-24.064-17.408-44.544-41.472-45.568h-2.048c-24.064 0-43.52 19.456-43.52 43.52v2.048l13.312 300.032c0.512 15.872 13.824 28.672 30.208 28.672z m-0.512 43.008c-13.824-0.512-27.648 4.608-37.376 14.848-10.752 9.216-16.896 23.04-15.872 37.376-0.512 14.336 5.632 27.648 15.872 37.376 9.728 10.24 23.04 15.872 37.376 15.36 14.336 0 28.16-5.12 38.912-14.848 10.24-9.728 15.872-23.552 15.36-37.888 0.512-13.824-5.12-27.648-15.36-37.376-10.752-10.24-24.576-15.36-38.912-14.848z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/zhuyi.svg
// module id = AELy
// module chunks = 16